import styled from 'styled-components';
import cross from '../../assets/addStockModal/pages/cross.svg';
import check from '../../assets/addStockModal/pages/check.svg';

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
  width: 70%;
  max-width: 900px;
  min-height: 400px;
`;

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 2.8vh;
  margin-left: 1.2vw;
  margin-right: 0.7vw;
  padding-right: 1rem;
`;

export const HeaderText = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.4vw;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0;
`;

export const CloseDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2vw;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;

  :hover {
    background-color: #f4f4f4;
  }
`;

export const CloseImg = styled.img`
  width: 0.8vw;
`;

export const ContentWrapper = styled.div`
  display: flex;
  gap: 2rem;
  padding: 1.5rem;
  min-height: 300px;
`;

export const LeftColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const RightColumn = styled.div`
  flex: 1.5;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-left: 2rem;
  border-left: 1px solid #e5e5e5;
`;

export const SwitchDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const InputLabel = styled.label`
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
`;

export const SwitchBox = styled.label`
  display: inline-block;
  position: relative;
  width: 60px;
  height: 34px;
`;

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  :checked + .slider {
    background-color: #2196F3;
    border: 0;
    padding: 2px;
  }

  :focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }

  :checked + .slider:before {
    background-image: url(${check});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 15px 15px;
    background-color: #fff;
    -webkit-transform: translateX(24px);
    -ms-transform: translateX(24px);
    transform: translateX(24px);
  }
`;

export const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;
  border: #696969 2px solid;

  :before {
    display: block;
    position: relative;
    content: "";
    height: 24px;
    width: 24px;
    left: 5.5px;
    top: 2.8px;
    background-color: #696969;
    border-radius: 50%;
    transition: all 0.4s;
    background-image: url(${cross});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 11px 11px;
  }
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const InfoTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin: 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #f0f0f0;
`;

export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 150px;
  overflow-y: auto;
  padding-right: 0.5rem;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const InfoItem = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: #555;
  padding: 0.4rem 0.8rem;
  background-color: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #2196F3;
`;

export const FilterItem = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: #555;
  padding: 0.4rem 0.8rem;
  background-color: #fff3cd;
  border-radius: 6px;
  border-left: 3px solid #ffc107;
  
  strong {
    color: #333;
    font-weight: 600;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: auto;
  padding-top: 1rem;
`;

export const ButtonCreate = styled.button`
  width: 100%;
  padding: 0.8rem 1.5rem;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;

  :hover {
    background-color: #1976D2;
  }

  :active {
    transform: translateY(1px);
  }
`;